import React from "react";
import ReactSelect from "@ui/ReactSelect";
import { useSystemsInput } from "./useSystemInput";

interface P {
  name: string;
  placeholder: string;
  entry: { systemId: string | null };
  column: string;
  allowSystemCreation?: boolean;
  setDirty: (dirty: boolean, column: string) => void;
}

const SystemSelect = (
  { name, placeholder, setDirty, entry, allowSystemCreation = false, ...props }: P,
  forwardedRef: React.Ref<HTMLDivElement>,
) => {
  const systemInput = useSystemsInput(entry);

  React.useEffect(() => {
    setDirty(systemInput.dirty, props.column);
  }, [systemInput.dirty, props.column, setDirty]);

  return (
    <ReactSelect
      {...props}
      menuPortalTarget={window.document.body}
      ref={forwardedRef}
      name={name}
      placeholder={placeholder}
      value={systemInput.selectedSystem}
      options={systemInput.systemOptions}
      onChange={systemInput.handleSystemChanged}
      onCreate={allowSystemCreation ? systemInput.handleSystemCreated : undefined}
      onEdit={allowSystemCreation ? systemInput.handleSystemEdited : undefined}
      onDelete={allowSystemCreation ? systemInput.handleSystemDeleted : undefined}
    />
  );
};

export default React.memo(React.forwardRef(SystemSelect));
